module.exports = __webpack_public_path__ + "img/HUN.47f860ed.svg";